class B2BAddToCart extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('product-id');
    this.variantId = this.getAttribute('variant-id');
    this.quantity = 0;
    this.render();
  }

  connectedCallback() {
    this.fetchQuantity();
    const incBtn = this.querySelector('.qty-btn--increase');
    const decBtn = this.querySelector('.qty-btn--decrease');
    if (incBtn) incBtn.addEventListener('click', () => this.changeQty(1));
    if (decBtn) decBtn.addEventListener('click', () => this.changeQty(-1));
  }

  /**
   * @param {any} i
   */
  isMatchingVariant(i) {
    return String(i.variant_id) === String(this.variantId);
  }

  async fetchQuantity() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const item = cart.items.find(i => this.isMatchingVariant(i));
      this.quantity = item ? item.quantity : 0;
      this.updateQtyDisplay();
    } catch (e) {
      this.showError('Failed to fetch cart.');
    }
  }

  /**
   * @param {number} delta
   */
  async changeQty(delta) {
    const newQty = Math.max(0, this.quantity + delta);
    const variantId = this.variantId;
    try {
      // Collect all cart-items-component section IDs
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      /** @type {string[]} */
      let sectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });
      let sections = {};
      if (delta > 0 && this.quantity === 0) {
        // Add new item using /cart/add.js with sections param
        const body = {
          id: variantId,
          quantity: 1,
          properties: { _added_from: window.NF_ADDED_FROM_PAGE || 'Other' },
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        };
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        const response = await res.json();
        sections = response.sections || {};
        await this.fetchQuantity();
      } else {
        // Update or remove using /cart/change.js with sections param
        const body = {
          id: variantId,
          quantity: newQty,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        };
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        const response = await res.json();
        sections = response.sections || {};
        await this.fetchQuantity();
      }
      
      const cartAddEvent = new CustomEvent('cart:add', {
        detail: {
          source: 'b2b-add-to-cart',
          itemCount: this.quantity,
          variantId: this.variantId,
          productId: this.productId,
          sections
        }
      });
      document.dispatchEvent(cartAddEvent);
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        console.log('cart-drawer-component found. auto-open:', cartDrawer.hasAttribute('auto-open'));
        const drawer = /** @type {any} */ (cartDrawer);
        if (typeof drawer.open === 'function') {
          console.log('Calling cartDrawer.open()');
          drawer.open();
        } else {
          console.warn('cartDrawer.open is not a function');
        }
      } else {
        console.warn('cart-drawer-component not found in DOM');
      }
      // Dispatch a cart:update event for theme compatibility
      if (
        sections &&
        typeof sections === 'object' &&
        Object.keys(sections).length > 0 &&
        Object.values(sections).every(html => typeof html === 'string' && html.trim() !== '')
      ) {
        const event = new CustomEvent('cart:update', {
          detail: {
            itemCount: this.quantity,
            sections,
            data: { sections, itemCount: this.quantity }
          }
        });
        document.dispatchEvent(event);
      }
    } catch (e) {
      this.showError('Cart update failed.');
    }
  }

  updateQtyDisplay() {
    const qtyDisplay = this.querySelector('.qty-display');
    if (qtyDisplay) qtyDisplay.textContent = String(this.quantity);
  }

  /**
   * @param {string} msg
   */
  showError(msg) {
    let error = this.querySelector('.b2b-qty-error');
    if (!error) {
      error = document.createElement('div');
      error.className = 'b2b-qty-error nf-mt-2 nf-text-red-600 nf-text-sm';
      this.appendChild(error);
    }
    if (error) {
      error.textContent = msg;
      setTimeout(function() { if (error && error.textContent) error.textContent = ''; }, 3000);
    }
  }

  render() {
    this.innerHTML = `
      <div class="nf-flex nf-items-center nf-gap-2 nf-bg-white nf-border nf-border-gray-300 nf-rounded-lg nf-shadow-sm nf-py-1 nf-px-3 nf-min-w-0 nf-w-full nf-min-h-12 nf-max-w-[340px] nf-mx-auto nf-justify-between nf-box-border nf-text-gray-500">
        <button class="nf-bg-none nf-border-0 nf-rounded nf-w-9 nf-h-8 nf-text-2xl nf-text-gray-400 nf-cursor-pointer nf-transition nf-duration-150 nf-ease-in-out hover:nf-bg-gray-100 hover:nf-text-gray-900 active:nf-bg-gray-200 disabled:nf-opacity-50 disabled:nf-cursor-not-allowed qty-btn qty-btn--decrease" aria-label="Decrease quantity" type="button">–</button>
        <span class="nf-min-w-[2.5em] nf-text-center nf-text-lg nf-text-gray-900 nf-font-medium nf-tracking-wide qty-display" aria-live="polite">0</span>
        <button class="nf-bg-none nf-border-0 nf-rounded nf-w-9 nf-h-8 nf-text-2xl nf-text-gray-400 nf-cursor-pointer nf-transition nf-duration-150 nf-ease-in-out hover:nf-bg-gray-100 hover:nf-text-gray-900 active:nf-bg-gray-200 disabled:nf-opacity-50 disabled:nf-cursor-not-allowed qty-btn qty-btn--increase" aria-label="Increase quantity" type="button">+</button>
      </div>
      <div class="b2b-qty-error nf-mt-2 nf-text-red-600 nf-text-sm" style="display:none;"></div>
    `;
  }
}

customElements.define('b2b-add-to-cart', B2BAddToCart);

// New custom element for product content output
class B2BProductContent extends HTMLElement {
  static get observedAttributes() {
    return ['product-page-url'];
  }

  /**
   * @param {string} name
   * @param {string|null} oldValue
   * @param {string|null} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'product-page-url' && newValue) {
      this.renderProductContent(newValue);
    }
  }

  /**
   * @param {string} productPageUrl
   */
  async renderProductContent(productPageUrl) {
    try {
      const response = await fetch(productPageUrl);
      if (!response.ok) throw new Error('Failed to fetch product page');
      const htmlText = await response.text();
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');
      const productGrid = doc.querySelector('[data-product-grid-content]');
      if (productGrid) {
        this.innerHTML = productGrid.innerHTML;
      }
    } catch (e) {
      this.innerHTML = '<div style="color:red;">Failed to load product info.</div>';
    }
  }
}

customElements.define('b2b-product-content', B2BProductContent);

/**
 * Renders a 'Choose Options' button that loads <b2b-product-content> on click.
 * @param {string} productPageUrl - The product page URL to fetch.
 * @param {HTMLElement} container - The container to render the button and product content into.
 */
function renderB2BChooseOptionsButton(productPageUrl, container) {
  if (!container) return;
  container.innerHTML = '';
  const button = document.createElement('button');
  button.textContent = 'Choose Options';
  button.addEventListener('click', () => {
    // Only create and append the product content on click
    if (!container.querySelector('b2b-product-content')) {
      const productContent = document.createElement('b2b-product-content');
      productContent.setAttribute('product-page-url', productPageUrl);
      container.appendChild(productContent);
      button.disabled = true; // Optionally disable button after click
    }
  });
  container.appendChild(button);
}

// Custom element: <b2b-product-chooser>
/**
 * <b2b-product-chooser product-page-url="..."></b2b-product-chooser>
 *
 * - product-page-url: URL of the product page to fetch.
 *
 * This component fetches the product page, extracts the main product content using common selectors, and injects it into the light DOM so theme styles apply.
 *
 * Theme developers: Ensure your product page has a unique wrapper for the main product content that matches one of the following selectors:
 *   [data-product-grid-content], .product__info-wrapper, .product-single, .product-main
 */
class B2BProductChooser extends HTMLElement {
  /** @type {AbortController|null} */
  #abortController = null;

  constructor() {
    super();
    this.productPageUrl = this.getAttribute('product-page-url') || '';
    this.render();
  }

  /**
   * @param {string} url
   * @returns {Promise<string|null>}
   */
  async #getProductIdFromPage(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch product page');
      const htmlText = await response.text();
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');
      // Try to find product-form-component with data-product-id
      const form = doc.querySelector('product-form-component[data-product-id]');
      if (form) {
        return form.getAttribute('data-product-id');
      }
      // Fallback: try meta tag
      const meta = doc.querySelector('meta[name="product:id"]');
      if (meta) {
        return meta.getAttribute('content');
      }
    } catch (e) {}
    return null;
  }

  render() {
    this.innerHTML = `
      <button id="choose-btn" class="b2b-choose-btn nf-block nf-w-full nf-min-w-0 nf-min-h-12 nf-max-w-[340px] nf-bg-white nf-border nf-border-gray-300 nf-rounded-lg nf-shadow-sm nf-py-1 nf-px-3 nf-text-gray-500 nf-text-base nf-font-medium nf-tracking-wide nf-cursor-pointer nf-transition nf-duration-150 nf-ease-in-out nf-text-center nf-outline-none nf-box-border nf-mx-auto focus:nf-border-blue-600 focus:nf-text-gray-900 focus:nf-shadow-outline-blue hover:nf-border-gray-700 hover:nf-text-gray-900 disabled:nf-opacity-50 disabled:nf-cursor-not-allowed" type="button">Choose options</button>
    `;
    const chooseBtn = this.querySelector('#choose-btn');
    if (!(chooseBtn instanceof HTMLButtonElement)) return;
    chooseBtn.onclick = async () => {
      chooseBtn.disabled = true;
      let productId = null;
      productId = await this.#getProductIdFromPage(this.productPageUrl);
      if (!productId) {
        chooseBtn.disabled = false;
        alert('Could not find product id for quick add.');
        return;
      }
      const quickAddBtn = document.querySelector(
        `product-form-component[data-product-id="${productId}"] .quick-add__button--choose`
      );
      if (quickAddBtn && quickAddBtn instanceof HTMLButtonElement) {
        quickAddBtn.click();
      } else {
        alert('Quick add button not found for this product.');
      }
      chooseBtn.disabled = false;
    };
  }
}

customElements.define('b2b-product-chooser', B2BProductChooser);